import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const TaxAccounting = React.lazy(
  () => import("../../../containers/pages/tax-accounting"),
);

const TaxAccountingPages = ({ match }) => (
  <div className="dashboard-wrapper">
    <Suspense fallback={<div className="loading" />}>
      <Switch>
        <Route path={`${match.url}/`} render={(props) => <TaxAccounting {...props} />} />
        <Redirect to="/error" />
      </Switch>
    </Suspense>
  </div>
);

export default TaxAccountingPages;
